module.exports = __webpack_public_path__ + "img/03203556000173.8ad37b27.png";